import { createFileRoute } from '@tanstack/react-router';

import { AssetPage } from '@/components/Pages/AssetPage';

export const Route = createFileRoute('/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId')({
  component: Page,
});

function Page() {
  const { organizationName, pdfVersionNodeId, pageVersionNodeId } = Route.useParams();
  const { versionId } = Route.useSearch();

  return (
    <AssetPage
      pageVersionNodeId={pageVersionNodeId}
      backTo="/$organizationName/pdf/$pdfVersionNodeId/autodocs"
      backParams={{ organizationName, pdfVersionNodeId }}
      backSearch={versionId ? { versionId } : undefined}
    />
  );
}
